import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Icon } from '@dixa/lib-shared-habla';
import { shallowEqual } from 'react-redux';
import { getLatestFacebookConversation } from 'components/conversation/selectors';
import { canConversationTransferToQueue } from 'components/conversation/utils/conversationTransfer';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { TransferToQueueDropdown } from './components/transferToQueueDropdown/transferToQueueDropdown';
import styles from './conversationTransferToQueue.module.scss';
export const ConversationTransferToQueue = () => {
    var _a;
    const [metaConversation, conversationAsyncStatus, latestMessengerConversation,] = useAppSelector((state) => [
        state.conversation.metaConversation,
        state.conversation.asyncStatus.getConversation,
        getLatestFacebookConversation(state),
    ], shallowEqual);
    const canTransferToQueue = canConversationTransferToQueue(metaConversation, latestMessengerConversation);
    return canTransferToQueue ? (_jsx(TransferToQueueDropdown, {})) : (_jsx(Button, Object.assign({ variant: "tertiary", disabled: true, isLoading: conversationAsyncStatus === 'loading', slotStart: _jsx(Icon, { name: "flow" }), className: styles.button }, { children: ((_a = metaConversation.conversation.queue) === null || _a === void 0 ? void 0 : _a.name) || `Not in queue` })));
};
